import * as React from 'react';
import * as Sauce from "Sauce";
import * as Immutable from "Immutable";
import { items as software_project_items } from "Showcase/ShowCaseItem";
import { ShowCase } from "Showcase/Component/ShowCase";
import { Func, SimpleParametricCurve2, ParametricCurve2 } from "Math/ParametricCurve"
import { Plotter } from "UI/Math/Plotter";
import * as Rx from "RxJs";
import * as $ from "jquery";
import * as ReactDOM from 'react-dom';
import { Oscilloscope, OscilloscopeController, OscilloscopeProps } from "UI/Math/Oscilloscope";
import * as Util from "Util";
import { merge } from "Util";
require("./Parametric.scss");
import * as _ from "lodash";
import * as math from 'mathjs';
import { Latex } from "UI/Math/Latex";

$(document).ready(() => {
    // Todo: what's a better way to handle multiple pages in one bundle.
    let p = document.getElementById("parametric");
    if (p) {
        ReactDOM.render(React.createElement(Parametric), p);
    }
})

interface Props {  }
interface State { osc?: OscilloscopeProps }
//Todo: need latex
export class Parametric extends Sauce.Component<Props,State> {
    private receiveNewOscProps = (props: OscilloscopeProps) => {
        this.setState({ osc: props });
    };
    
    constructor(props:any) {
        super(props);

        let initial_state: State = { osc: undefined };
        this.state = initial_state;
    }

    render() {
        let osc: any;
        if (this.state.osc && this.state.osc.curve) {
            osc = <Oscilloscope
                key={"osc1"}
                curve={this.state.osc.curve}
                tmin={this.state.osc.tmin} tmax={this.state.osc.tmax} 
                xmin={this.state.osc.xmin} xmax={this.state.osc.xmax} ymin={this.state.osc.ymin} ymax={this.state.osc.ymax}
                autoplay={true} repeat={this.state.osc.repeat} duration={this.state.osc.duration} repeatDelay={this.state.osc.repeatDelay}
                numSamples={1000}/>;
        }
        else {
            osc = <div className="error-msg">Invalid curve, can't graph</div>;
        }
        
        return <div className="parametric-root">
                {osc}
                <div>
                    These expressions are parsed using <a href="http://mathjs.org/docs/expressions/syntax.html">mathjs</a>
                </div>
                <OscilloscopeController
                    flush={this.receiveNewOscProps}
                    autoplay={true}
                    startx={"sin(t) * (e^cos(t) - 2 * cos(4t) - sin(t/12)^6)"} 
                    starty={"cos(t) * (e^cos(t) - 2 * cos(4t) - sin(t/12)^6)"}
                    tmin={"-6 * pi"} tmax={"6 * pi"} 
                    xmin={"-5"} xmax={"5"} ymin={-5} ymax={5}
                    repeat={true} 
                    duration={"10 * 1000"} repeatDelay={3000}
                    numSamples={500}
                />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/code/Showcase/Component/Parametric.tsx